module.exports = __webpack_public_path__ + "static/media/admin-servicios-productos.645cb451.svg";